export default __webpack_public_path__ + "static/media/telephone.cad620fd.svg";